// extracted by mini-css-extract-plugin
export default {"container":"_1SvQB","title":"OJt3y"};